import {
  DeleteTargetRate,
  DeleteTargetRateVariables,
} from "_graphql/mutation/__generated__/DeleteTargetRate";

import { PopUp } from "components";
import { deleteTargetRate } from "../../_graphql/visal/mutations/target-rate";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useTargetRate } from "hooks/data/use-target-rates";

export default function RemoveTargetRateContainer({
  open,
  setOpen,
  rateId,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  rateId: string;
  refetch?: () => void;
}) {
  const { loading, targetRate } = useTargetRate(rateId);

  const [execute, { loading: deleting }] = useMutation<
    DeleteTargetRate,
    DeleteTargetRateVariables
  >(deleteTargetRate, {
    refetchQueries: ["fetchTargetRates"],
  });

  const handleSubmit = async () => {
    await execute({
      variables: {
        targetRateId: rateId || "",
      },
    })
      .then(({ data }) => {
        if (data?.deleteTargetRate) {
          toast.success("Rate deleted successfully");
          refetch?.();
          setOpen(false);
        } else {
          toast.error("Failed to delete rate");
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Delete Rate"
      cancelText="No, Don't Delete Rate"
      description={`Are you sure you want to delete this rate (${targetRate?.currency_code} ${targetRate?.rate_value})? This will permanently delete this rate from the target. This action cannot be undone.`}
      renderActions={() => (
        <button
          type="button"
          disabled={deleting}
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={handleSubmit}
        >
          {deleting ? "Deleting..." : "Delete Rate"}
        </button>
      )}
    />
  );
}
